// src/serviceWorkerRegistration.js

// This file lets you control how to register/unregister service workers.
// We’ll use unregister() for online-only PWAs.

export function register() {
  // Don’t do anything — since you want online-only
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then(registration => {
        registration.unregister();
      })
      .catch(error => {
        console.error(error.message);
      });
  }
}
